import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["Substation"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getSubstation: build.query<GetSubstationApiResponse, GetSubstationApiArg>(
        {
          query: () => ({ url: `/Substation` }),
          providesTags: ["Substation"],
        }
      ),
      putSubstationByName: build.mutation<
        PutSubstationByNameApiResponse,
        PutSubstationByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/Substation/${queryArg.name}`,
          method: "PUT",
          body: queryArg.substationDto,
        }),
        invalidatesTags: ["Substation"],
      }),
      deleteSubstationByName: build.mutation<
        DeleteSubstationByNameApiResponse,
        DeleteSubstationByNameApiArg
      >({
        query: (queryArg) => ({
          url: `/Substation/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["Substation"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as substationApi };
export type GetSubstationApiResponse = /** status 200 OK */ SubstationDto[];
export type GetSubstationApiArg = void;
export type PutSubstationByNameApiResponse = /** status 200 OK */ void;
export type PutSubstationByNameApiArg = {
  name: string;
  substationDto: SubstationDto;
};
export type DeleteSubstationByNameApiResponse = unknown;
export type DeleteSubstationByNameApiArg = string;
export type SubstationDto = {
  name: string;
  shortName?: string | null;
  latitude?: number;
  longitude?: number;
  comment?: string | null;
  isUsed: boolean;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetSubstationQuery,
  useLazyGetSubstationQuery,
  usePutSubstationByNameMutation,
  useDeleteSubstationByNameMutation,
} = injectedRtkApi;
